// WhatsAppLink.js
import React from "react"
import * as styles from "./WhatsAppLink.module.scss"

const WhatsAppLink = ({ phoneNumber, message, loading }) => {
  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message)
    const link = `https://wa.me/${phoneNumber}?text=${encodedMessage}`
    window.open(link, "_blank", "noopener,noreferrer")
  }

  return (
    <div
      className={styles.whatsapp}
      role="button"
      onClick={handleClick}
      onKeyDown={e => (e.key === "Enter" || e.key === " ") && handleClick()}
      tabIndex={0}
      aria-label="Chat with us on WhatsApp"
    >
      <img
        src="/whatsapp.svg"
        width="44"
        height="44"
        alt="Chat with us on WhatsApp"
        loading={loading}
        className="WhatsApp-button"
      />
    </div>
  )
}

export default WhatsAppLink
